import { StyleSheet } from 'aphrodite';
import {
	actionItemTintColor,
	background,
	borderColor,
	brandPrimary,
	darkGrayFontColor,
	destructive,
	gray4,
	midGray,
	white,
} from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		marginBottom: 32,
	},
	header: {
		marginBottom: 16,
	},
	tableContainer: {
		alignItems: 'stretch',
		border: `1px solid ${borderColor}`,
		borderRadius: 10,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.1)',
		boxSizing: 'border-box',
		marginBottom: '1.5rem',
		padding: '20px 30px',
		marginTop: 24,
	},
	tableHeaderCell: {
		borderBottom: `1px solid ${borderColor}`,
		color: '#AAAAAA',
		fontSize: 11,
		letterSpacing: '1.1px',
		paddingBottom: 20,
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		minWidth: 150,
	},
	tableRow: {
		height: 40,
	},
	tableCell: {
		borderBottom: `1px solid ${borderColor}`,
	},
	maskedKey: {
		fontFamily: 'monospace',
		color: darkGrayFontColor,
		fontSize: 13,
	},
	consumerBadge: {
		backgroundColor: brandPrimary,
		color: white,
		padding: '4px 8px',
		borderRadius: 4,
		fontSize: 12,
		fontWeight: 500,
	},
	noDataContainer: {
		padding: 32,
		textAlign: 'center',
		backgroundColor: white,
		borderRadius: 8,
		border: `1px solid ${midGray}`,
	},
	infoContainer: {
		marginTop: 8,
		padding: 8,
		backgroundColor: background,
		borderRadius: 4,
		textAlign: 'center',
	},
	activeStatus: {
		color: actionItemTintColor,
		fontWeight: 500,
	},
	inactiveStatus: {
		color: gray4,
		fontWeight: 400,
	},
	neverUsedStatus: {
		color: destructive,
		fontWeight: 400,
	},
});
